import { render, staticRenderFns } from "./BrokerDetail.vue?vue&type=template&id=1794a425&scoped=true&"
import script from "./BrokerDetail.vue?vue&type=script&lang=js&"
export * from "./BrokerDetail.vue?vue&type=script&lang=js&"
import style0 from "./BrokerDetail.vue?vue&type=style&index=0&id=1794a425&scoped=true&lang=css&"
import style1 from "./BrokerDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1794a425",
  null
  
)

export default component.exports